import {Component, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SuccessStoryItemComponent} from "../success-story-item/success-story-item.component";
import {DragScrollDirective} from "../../../directives/drag-scroll.directive";
import {TemplateComponent} from "../../template/template.component";
import {CommonModule} from "@angular/common";
import {Setting} from "../../../dto/Setting";
import {Pages} from "../../../dto/Pages";

@Component({
    selector: 'app-success-story',
    standalone: true,
    imports: [
        SuccessStoryItemComponent,
        DragScrollDirective,
        CommonModule
    ],
    templateUrl: './success-story.component.html',
    styleUrl: './success-story.component.css'
})
export class SuccessStoryComponent extends TemplateComponent implements OnInit {
    @Input() showDet: boolean = true;
    @Input() title: string = $localize`:@@Success Stories:Success Stories`;
    pages: Array<Pages> = new Array<Pages>();
    @ViewChild("items") itemsDiv: HTMLDivElement;

    ngOnInit() {

        setTimeout(() => {
            this.loadPageData();
        }, 0)


    }

    right(items: HTMLDivElement) {
        // @ts-ignore
        let tmp = items.children[0].offsetWidth;
        items.scrollBy({
            left: tmp,
            top: 0,
            behavior: 'smooth'
        });
        items.onscrollend = (event) => {
            if (this.getDirection() == 'rtl') {
                if ((items.scrollLeft * -1) < tmp)
                    items.scrollLeft = 0;

            }
            items.click();
        }
    }

    left(items: HTMLDivElement) {
        // @ts-ignore
        let tmp = items.children[0].offsetWidth;
        items.scrollBy({
            left: tmp * -1,
            top: 0,
            behavior: 'smooth'
        });
        items.onscrollend = (event) => {
            items.click();
        }
    }

    goToStoryListPage() {
        this.route.navigate(["/stories"]);
    }

    loadPageData() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/site/get_page_list?" +
            "page=0" +
            "&nrpp=6" +
            "&type=SUCCESS_STORY" +
            "");
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.pages = res["entity"];


                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
                this.cdr.detectChanges();
            }
        });
    }
}
